import { UploadFile } from "@egovernments/digit-ui-react-components";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const DocUploader = ({ uploadedFile, setUploadedFile }) => {
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const { t } = useTranslation();
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 20971520) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file?.type && !allowedFileTypesRegex.test(file?.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            const tenantId = Digit.ULBService.getCurrentTenantId();
            console.log("[DEBUG] DocUploader uploading file, tenantId:", tenantId);
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || tenantId?.split(".")[0]);
            if (response?.data?.files?.length > 0) {
              const fileStoreId = response?.data?.files[0]?.fileStoreId;
              console.log("[DEBUG] DocUploader setUploadedFile called with:", fileStoreId);
              localStorage.setItem("wf_verification_doc", fileStoreId);
              setUploadedFile(fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  return (
    <React.Fragment>
      {" "}
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn="span 2" sx={{ fontWeight: "bold", marginTop: "5px", marginLeft: "5px", whiteSpace: "nowrap",fontSize: "14px" }}>
          Document/Certificate 
        </Box>
        <Box gridColumn="span 10" sx={{  marginLeft: "20px" }}>
          <UploadFile
            id={"workflow-doc"}
            onUpload={selectFile}
            onDelete={() => {
              localStorage.removeItem("wf_verification_doc");
              setUploadedFile(null);
            }}
            message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
            accept="image/*, .pdf, .png, .jpeg, .jpg"
            iserror={error}
          />
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default DocUploader;
